import {
  MaskConfiguration,
  MaskConstants,
} from 'libs/constants/mask-constants';
import { RegexConstants } from 'libs/constants/regex-constants';

export const IbanConstants: {
  [prefix: string]: { regex: RegExp; mask: MaskConfiguration };
} = {
  AT: {
    mask: MaskConstants.IbanATConfig,
    regex: RegexConstants.IbanAT,
  },
  BE: {
    mask: MaskConstants.IbanBEConfig,
    regex: RegexConstants.IbanBE,
  },
  CY: {
    mask: MaskConstants.IbanCYConfig,
    regex: RegexConstants.IbanCY,
  },
  DE: {
    mask: MaskConstants.IbanDEConfig,
    regex: RegexConstants.IbanDE,
  },
  ES: {
    mask: MaskConstants.IbanESConfig,
    regex: RegexConstants.IbanES,
  },
  EE: {
    mask: MaskConstants.IbanEEConfig,
    regex: RegexConstants.IbanEE,
  },
  FI: {
    mask: MaskConstants.IbanFIConfig,
    regex: RegexConstants.IbanFI,
  },
  FR: {
    mask: MaskConstants.IbanFRConfig,
    regex: RegexConstants.IbanFR,
  },
  GR: {
    mask: MaskConstants.IbanGRConfig,
    regex: RegexConstants.IbanGR,
  },
  IE: {
    mask: MaskConstants.IbanIEConfig,
    regex: RegexConstants.IbanIE,
  },
  IT: {
    mask: MaskConstants.IbanITConfig,
    regex: RegexConstants.IbanIT,
  },
  LV: {
    mask: MaskConstants.IbanLVConfig,
    regex: RegexConstants.IbanLV,
  },
  LT: {
    mask: MaskConstants.IbanLTConfig,
    regex: RegexConstants.IbanLT,
  },
  LU: {
    mask: MaskConstants.IbanLUConfig,
    regex: RegexConstants.IbanLU,
  },
  MT: {
    mask: MaskConstants.IbanMTConfig,
    regex: RegexConstants.IbanMT,
  },
  NL: {
    mask: MaskConstants.IbanNLConfig,
    regex: RegexConstants.IbanNL,
  },
  PT: {
    mask: MaskConstants.IbanPTConfig,
    regex: RegexConstants.IbanPT,
  },
  SK: {
    mask: MaskConstants.IbanSKConfig,
    regex: RegexConstants.IbanSK,
  },
  SI: {
    mask: MaskConstants.IbanSIConfig,
    regex: RegexConstants.IbanSI,
  },
};
